import React from "react";
import { Button, Flex, Icon, Text, Tooltip } from "@chakra-ui/react";
import {
  buttonRed,
  buttonRedText,
  color8,
  primaryAlt,
  textSecondary,
  white,
} from "../../utils/colors";
import { FaCaretDown, FaUser } from "react-icons/fa6";
import useThemeColors from "../../hooks/useThemeColors";
import { useTranslation } from "react-i18next";

const UserSelectButton = ({
  user,
  onClick,
  isOpen,
  isSecondary,
  noUserLabel,
  isEmail,
  isLocked,
  tpStatus,
  isEdit,
}) => {
  const { t } = useTranslation();
  const { whiteMode, backgroundLightMode, textPrimaryMode } = useThemeColors();

  // console.log("UserSelectButton", user);
  // console.log("isOpen", isOpen);

  const primaryColor = isSecondary ? color8 : textPrimaryMode;

  // console.log("tpStatus", tpStatus);

  return (
    <Tooltip
      p="0.5rem 1rem"
      borderRadius="1rem"
      placement="top"
      label={
        <Flex
          direction="column"
          align="center"
          justify="center"
          textAlign="center"
        >
          <Text fontSize="xs" fontWeight="500">
            {isEdit
              ? t("warnings.tooltipPatientSelectEditText")
              : t("warnings.tooltipPatientSelectText")}
          </Text>
        </Flex>
      }
      isDisabled={tpStatus === "draft" || tpStatus === "planning"}
    >
      <Button
        size="sm"
        align="center"
        h="28px"
        bg={user ? backgroundLightMode : buttonRed}
        p="0.25rem 0.5rem"
        borderRadius="10rem"
        onClick={onClick}
        role="group"
        isDisabled={isLocked}
        _hover={{ bg: primaryAlt, cursor: "pointer" }}
        _disabled={{
          cursor: "not-allowed",
          _hover: {
            cursor: "not-allowed",
          },
        }}
      >
        {user && user ? (
          <>
            <Flex
              align="center"
              justify="center"
              bg={isSecondary ? color8 : textPrimaryMode}
              h="1.35rem"
              w="1.35rem"
              borderRadius="50%"
              mr="0.25rem"
            >
              <Text fontSize="xs" color={whiteMode} fontWeight="500">
                {user && user.lastName && user.lastName[0]}
                {user && user.firstName && user.firstName[0]}
              </Text>
            </Flex>
            {isEmail ? (
              <Text
                fontSize="0.8rem"
                color={textPrimaryMode}
                fontWeight="500"
                _groupHover={{
                  color: white,
                }}
              >
                {user && user.email && user.email}
              </Text>
            ) : (
              <Text
                fontSize="0.8rem"
                color={textPrimaryMode}
                fontWeight="500"
                _groupHover={{
                  color: white,
                }}
                maxW="160px"
                isTruncated
              >
                {user && user.lastName && user.lastName}{" "}
                {user && user.firstName && user.firstName}
              </Text>
            )}
          </>
        ) : (
          <Flex
            // p="0.125rem 0"
            align="center"
            fontSize="0.8rem"
            color={user ? textPrimaryMode : buttonRedText}
            fontWeight="600"
            _groupHover={{
              color: white,
            }}
          >
            <Flex
              align="center"
              justify="center"
              bg={user ? primaryColor : buttonRedText}
              h="1.35rem"
              w="1.35rem"
              borderRadius="50%"
              mr="0.25rem"
            >
              <Icon
                as={FaUser}
                fontSize="0.6rem"
                color={isSecondary ? white : white}
              />
            </Flex>

            {noUserLabel}
          </Flex>
        )}
        {!isLocked && (
          <Icon
            as={FaCaretDown}
            h="0.75rem"
            w={isOpen ? "0.75rem" : !user ? "0.75rem" : "0.75rem"}
            ml={1}
            // transition="all 0.2s ease"
            color={
              isOpen ? textSecondary : !user ? textSecondary : textSecondary
            }
            opacity={isOpen ? 1 : !user ? 0.6 : 0.6}
            transform={isOpen ? "rotate(-180deg)" : "rotate(0deg)"}
            transition="all 0.2s ease"
            _groupHover={{
              color: isOpen ? textSecondary : !user ? white : white,
              opacity: 1,
              width: "0.75rem",
              transition: "all 0.2s ease",
            }}
          />
        )}
      </Button>
    </Tooltip>
  );
};

export default UserSelectButton;
